import { RefObject } from 'react';

import { resolveCssLengthToPx } from '@cast/utils';

export const resolveHeight = (
  rootRef: RefObject<HTMLElement | null>,
  height: number | string | undefined
): number | null => {
  if (height === undefined) {
    return null;
  }

  if (typeof height === 'number') {
    return height;
  }

  return resolveCssLengthToPx(height, rootRef.current ?? undefined);
};
